<template>
  <div>

    <div class="absolute z-40" v-if="!excluded_routes.includes($route.name)" style="bottom: 15rem; left: -1rem;">
      <img :src="getImage('santahat')" style="width: 20rem;" >
    </div>
    
    <!-- <div class="absolute z-60" v-if="$route.name === 'start-page'" style="top: -2rem; left: 50%; transform: translateX(-50%);">
        <img :src="getImage('garland')" style="width: 45rem;">
    </div> -->

    <div class="absolute z-60" v-if="$route.name === 'start-page'" style="bottom: -2rem; right: 0rem;">
        <img :src="getImage('gift-1')" class="papsi-cloud" style="width: 30rem;">
    </div>

    <div class="absolute z-60" v-if="$route.name === 'start-page'" style="bottom: -3rem; left: -4rem;">
        <img :src="getImage('gift-2')" class="papsi-cloud" style="width: 30rem;">
    </div>
    

    <div v-if="$route.name !== 'kiosk-login-page'" class="fixed w-full h-full pointer-events-none z-60 overflow-hidden" style="top: 0; left: 0;">
        <div
            class="papsi-snowflake"
            v-for="flake in snowflakes"
            :key="flake.id"
            :style="generateFlakeStyle(flake.id)">
        </div>
    </div>
  </div>
  </template>
  
  <script>
  import mixin from "@/mixins/controls.js";
  
  export default {
    mixins: [mixin],
    props: {
      density: {
        type: Number,
        default: 15,
      },
    },
    data() {
      return {
        snowflakes: [],
        excluded_routes: [
            "start-page", 
            "error",
            "kiosk-login-page",
            "selection-page",
            "choose-lang-page",
        ],
      };
    },
    mounted() {
      this.generateSnowflakes();
    },
    methods: {
      generateSnowflakes() {
        for (let i = 0; i < this.density; i++) {
          this.snowflakes.push({ id: i });
        }
      },
      generateFlakeStyle(index) {
        const sizes = [
          { width: "5px", height: "5px" },
          { width: "8px", height: "8px" },
          { width: "9px", height: "9px" },
          { width: "10px", height: "10px" },
        ];
        const size = sizes[index % sizes.length];
        return {
          "--random": Math.random(),
          width: size.width,
          height: size.height,
          animationDuration: `${12 + Math.random() * 3}s`,
          animationDelay: `${Math.random() * 10}s`,
          left: `${Math.random() * 100}%`,
        };
      },
    },
  };
  </script>
  
  <style scoped>
  
  .papsi-snowflake {
    position: absolute;
    top: -10%;
    background: white;
    border-radius: 50%;
    animation: fall linear infinite;
    opacity: 0.8;
  }

  .papsi-cloud {
    animation: enlarge-shrink 1.5s infinite;
    /* 2s duration, infinite loop */
}
  
  /* Snowflake falling animation */
  @keyframes fall {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(100vh);
    }
  }

  @keyframes enlarge-shrink {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
        /* Enlarge the image */
    }

    100% {
        transform: scale(1);
        /* Shrink back to original size */
    }
}
  </style>
  